import React, { type FC } from 'react'
import { Flex } from 'antd'
import { AddCircleRegular, TaskListSquareLtrRegular } from '@fluentui/react-icons'

import { IOktaUser } from '../../../constants/types/generatedTypesAliases'
import { ADD_PERMISSIONS, PERMISSIONS } from '../../../components/shared/constants'
import { ButtonWithTooltip } from '../../../components/shared'

interface IUserTableActionsProps {
  user: IOktaUser
  addPermissions: (user: IOktaUser) => void
  openUserDetails: (user: IOktaUser) => void
}

export const UserTableActions: FC<IUserTableActionsProps> = ({
  user,
  addPermissions,
  openUserDetails
}) => {
  return (
    <Flex justify='flex-end' gap={4}>
      <ButtonWithTooltip
        namespaceDependency={true}
        tooltipText={ADD_PERMISSIONS}
        type='link'
        data-testid={`user-add-permission-button-${user.id}`}
        onClick={() => addPermissions(user)}
        icon={<AddCircleRegular fontSize={20} />}
      />
      <ButtonWithTooltip
        namespaceDependency={true}
        tooltipText={PERMISSIONS}
        type='link'
        data-testid={`user-details-button-${user.id}`}
        onClick={() => openUserDetails(user)}
        icon={<TaskListSquareLtrRegular fontSize={20} />}
      />
    </Flex>
  )
}
